import { Component } from 'react';
import { actions, Control, Errors } from 'forms/rrf';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup, FormLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { validators } from '../../../../utils/validators';
import { nativeValidationMessages } from '../../../../utils/nativeValidationMessages';

class RequiredInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      required: false,
      isEmail: false,
      isPositive: false
    };
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onBlur = () => {
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur();
    }
  }

  changeAction = (model, value) => (dispatch) => {
    dispatch(actions.change(model, value));
    dispatch(actions.resetValidity(model));
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  };

  getValidationState = () => {
    const fields = ['required', 'isEmail', 'isPositive'];
    const validationArray = fields.map((field) => {
      if (this.state[field] === 'error') {
        return 'error';
      }
      return null;
    });

    if (validationArray.includes('error')) {
      return 'error';
    } else if (validationArray.includes('warning')) {
      return 'warning';
    } else if (validationArray.includes('success')) {
      return 'success';
    }

    return null;
  }

  render() {
    const {
      model, label, inputType, controlId, errorLabel, tooltip, debounce, groupClassName, additionalValidators, positive, zeroAllowed,
      messages,
      ...props
    } = this.props;
    const validationState = this.getValidationState();

    return (
      <FormGroup
        className={`form-group ${groupClassName || ''}${validationState ? ' has-'.concat(validationState) : ''}`}
        controlId={controlId}
      >
        {label && (
          <FormLabel>
            {label}
            *
          </FormLabel>
        )}
        {
          tooltip && (
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip" id="tooltip">
                  {tooltip}
                </Tooltip>
              )}
              placement="left"
            >
              <Button variant="default" className="tip float-end" tabIndex="-1">
                ?
              </Button>
            </OverlayTrigger>
          )
        }

        <Control
          onBlur={this.onBlur}
          changeAction={this.changeAction}
          component={FormControl}
          debounce={debounce || 0}
          model={model}
          type={inputType}
          validators={{
            ...additionalValidators,
            isEmail: model === '.email' ? validators.isEmail(this.updateErrors, 'isEmail') : () => true,
            required: zeroAllowed ? validators.requiredWithZero(this.updateErrors, 'required')
             : validators.required(this.updateErrors, 'required'),
            isPositive: positive ? validators.isPositive(this.updateErrors, 'isPositive') : () => true,
          }}
          {...props}
          onChange={false}
        />

        <Errors
          className="errors"
          messages={{
            ...nativeValidationMessages(this.props),
            required: 'This field is required',
            isEmail: 'Value is not a valid email',
            isPositive: 'Value must be positive',
            ...messages
          }}
          model={model}
          show={{
            touched: true,
            focus: false
          }}
        />
      </FormGroup>
    );
  }
}

RequiredInput.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  inputType: PropTypes.string,
  groupClassName: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
  debounce: PropTypes.number,
  additionalValidators: PropTypes.object,
  zeroAllowed: PropTypes.bool,
  messages: PropTypes.object
};

RequiredInput.defaultProps = {
  messages: {},
  inputType: 'text',
  groupClassName: '',
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
};

export default RequiredInput;
